import React, { useEffect } from 'react';
import { rceUtils } from './rce/rceUtils';
import { getTheme } from '../../selectors/ricosTheme';
import stylesParams from '../../components/ChallengesPage/stylesParams'; // todo: common way
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import settingsParams from '../../components/ChallengesPage/settingsParams';
import { TextAlignment } from '../../components/ChallengesPage/Settings/challengeSettings/challengeSettings.types';
import { useBi, useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { challengeStyles } from '../../components/ChallengesPage/Settings.mobile/challengeStyles';
import { useGeneralData } from '../../contexts/GeneralDataProvider/GeneralDataContext';
import { WixRicosViewer } from '@wix/ricos';
import '@wix/ricos/css/ricos-viewer.global.css';
import { useRicosContent } from './UseRicosContent';
import { useCSSPBEnabled } from '../../hooks/useCSSPBStyle';
import { useLoading } from '../../contexts/Loading/LoadingContext';

export interface IRicosProps {
  details: any;
  className?: string;
  dataHook?: string;
  contentId: string;
  alignment?: TextAlignment;
  context:
    | 'section_description'
    | 'program_step'
    | 'program_description'
    | 'instructor';
}

export const Ricos: React.FunctionComponent<IRicosProps> = (
  props: IRicosProps,
) => {
  const { details = null, className = '', dataHook = '' } = props;
  const { instance, host, defaultBIParams, msid } = useGeneralData();
  const { isMobile, language } = useEnvironment();
  const logger = useBi();

  const settings = useSettings();
  const styles = useStyles();
  const { experiments } = useExperiments();

  const fontKey = stylesParams.sidebarLayoutBodyDescriptionFont.key;
  const colorKey = stylesParams.sidebarLayoutBodyDescriptionColor.key;
  const bgColorKey = stylesParams.sidebarLayoutSidebarBackgroundColor.key;

  // We need to have an ability to set alignment (f.ex. for the Visitor page),
  //  and the default alignment is based on chosen page layout.
  const alignment =
    props.alignment || settings.get(settingsParams.sidebarLayoutTextAlignment);
  const cssPBEnabled = useCSSPBEnabled();
  const size = cssPBEnabled
    ? '--mobSidebarLayoutStepDescriptionFontSize'
    : styles.get(challengeStyles.mobSidebarLayoutStepDescriptionFontSize);
  const extendedFontSize = isMobile ? size : null;
  const content = useRicosContent(details);
  const { setRicosHasLoaded } = useLoading();

  useEffect(() => {
    setRicosHasLoaded(true);
  }, []);
  if (!content) {
    return null;
  }

  return (
    <div className={className} data-hook={dataHook}>
      <WixRicosViewer
        iframeSandboxDomain={`https://${msid}.filesusr.com`}
        wixExperiments={experiments}
        instance={instance}
        theme={getTheme({
          fontKey,
          extendedFontSize,
          colorKey,
          host,
          bgColorKey,
        })}
        // mediaSettings={{ disableRightClick: true, }}
        plugins={rceUtils.PLUGINS as any}
        content={content as any}
        biSettings={{
          consumer: 'Challenges.',
          platform: 'Livesite',
          defaultParams: defaultBIParams,
          contentId: props.contentId,
          postId: '',
          containerId: '',
          usage: props.context,
          logger,
        }}
        isMobile={isMobile}
        locale={language}
        textAlignment={alignment}
      />
    </div>
  );
};
Ricos.displayName = 'Ricos';
export default Ricos;
